<template>
  <v-layout
    column
    wrap
    class="pa-4"
    align-center
  >
    <Toggle
      v-model="notifications.host_notifications"
      title="Host Notifications"
      caption="Enable or disable E-mail and SMS notifications sent to host"
      @change="updateHost" 
    />
    <Toggle
      v-model="notifications.visitor_notifications"
      title="Visitor Notifications"
      caption="Enable or disable SMS notifications sent to visitor"
      @change="updateVisitor"
    />
    <template v-if="notifications.visitor_notifications">
      <v-container
        grid-list-lg
        style="max-width:750px"
        class="pa-1 pt-3"
      >
        <v-layout
          row
          wrap
        >
          <v-textarea
            id="textarea"
            :value="notifications.visitor_sms_text"
            label="Visitor SMS Text"
            rows="1"
            auto-grow
            counter="120"
            @input="visitorSmsTextChnaged" 
          />
          <v-menu offset-y>
            <v-btn
              slot="activator"
              color="primary"
              outline
            >
              Variables
              <v-icon color="iconColor">
                arrow_drop_down
              </v-icon>
            </v-btn>
            <v-list>
              <v-list-tile
                v-for="item in variables"
                :key="item.key"
                @click="variableSelected(item)"
              >
                <v-list-tile-title>{{ item.value }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-layout>
      </v-container>
    </template>
    <Toggle
      v-model="notifications.forward_notifications"
      title="Forward Notifications"
      caption="Email Notifications can be forwarded to atmost 3 employees."
      @change="updateForwardNotificaitons"
    />
    <v-layout
      v-if="notifications.forward_notifications"
      column
      align-center
      wrap
    >
      <div
        v-for="(contact, index) in notifications.forward_notifications_to"
        :key="index"
      >
        <v-layout
          row
          wrap
          style="width:450px"
        >
          <span class="subheading pr-3 pt-4">
            {{ index + 1 }}.
          </span>
          <vizmo-autocomplete
            :items="employees"
            :disabled="!notifications.forward_notifications"
            :value="contact"
            label="Host"
            class="pt-3"
            placeholder="Type to search Employees"
            @change="(val) => notifications.forward_notifications_to[index] = val"
          />
        </v-layout>
      </div>
    </v-layout>
  </v-layout>
</template>
<script>
import _get from 'lodash/get';
import _cloneDeep from 'lodash/cloneDeep';
import { database } from '@/firebase';

import Toggle from '@/components/common/Toggle';
import vizmoAutoComplete from '@/components/common/VizmoAutoComplete';

export default {
  name: 'Notificaitons',
  components: {
    Toggle,
    'vizmo-autocomplete': vizmoAutoComplete
  },
  props: {
    data: {
      type: Object,
      default: null,
      required: true
    }
  },
  data() {
    return {
      notifications: {},
      variables: [
        {
          key: '{{hostName}}',
          value: 'Host Name'
        },
        {
          key: '{{visitorName}}',
          value: 'Visitor Name'
        },
        {
          key: '{{locationName}}',
          value: 'Location Name'
        },
        {
          key: '{{companyName}}',
          value: 'Company Name'
        }
      ],

      fields: [1, 2, 3],
      search: '',
      employees: []
    };
  },
  computed: {
    locationId() {
      return _get(this.$store.state.location, 'lid');
    },
    expansionPanel() {
      return this.notifications.forward_notifications ? 0 : 1;
    }
  },
  watch: {
    locationId: {
      handler(val) {
        if (val) this.fetchEmployees();
      },
      immediate: true
    },
    data: {
      handler(val) {
        if (!val) return;
        this.notifications = _cloneDeep(val);
      },
      immediate: true,
      deep: true
    }
  },
  deactivated() {
    const validation = true;
    this.$emit('update', [this.notifications, validation]);
  },
  methods: {
    fetchEmployees() {
      const path = `companies/${this.$store.state.profile.cid}/${
        this.locationId
      }/employees`;
      database.ref(path).once('value', employeeSnapshot => {
        if (!employeeSnapshot.val()) return;
        this.componentLoading = false;
        this.employees = this._toArray(employeeSnapshot.val());
      });
    },

    _toArray(obj) {
      if (!obj) return [];
      return Object.keys(obj).map(key => ({
        id: key,
        name: obj[key].name,
        email: obj[key].email,
        phone: obj[key].phone || ''
      }));
    },

    updateHost(val) {
      this.notifications.host_notifications = val;
    },

    updateVisitor(val) {
      this.notifications.visitor_notifications = val;
    },

    visitorSmsTextChnaged(val) {
      const t = this.notifications.visitor_sms_text;

      const diff = this.getStringDiff(val, t);

      if (diff === '}') {
        // position before deletion
        const position = document.getElementById('textarea').selectionStart + 1;
        // replace last variable using lookahead
        const modified =
          t
            .substring(0, position)
            .replace(/\{{([^}]+)\}}(?!.*?\{{([^}]+)\}})/g, '') +
          t.substring(position);
        this.notifications.visitor_sms_text = modified;
      } else {
        this.notifications.visitor_sms_text = val;
      }
    },
    variableSelected(val) {
      const position = document.getElementById('textarea').selectionStart;
      const text = this.insert(
        this.notifications.visitor_sms_text,
        val.key,
        position
      );
      this.notifications.visitor_sms_text = text;
    },

    insert(mainString, insString, pos) {
      return mainString.slice(0, pos) + insString + mainString.slice(pos);
    },

    updateForwardNotificaitons(val) {
      this.notifications.forward_notifications = val;
    },

    getStringDiff(a, b) {
      let i = 0;
      let j = 0;
      let result = '';

      while (j < b.length) {
        if (a[i] !== b[j] || i === a.length) {
          result += b[j];
        } else {
          i += 1;
        }
        j += 1;
      }
      return result;
    }
  }
};
</script>

